<div class="controls-row" role="toolbar" aria-label="Chart controls">
  <div class="control-group">
    <span class="control-label">Color by</span>
    <mat-button-toggle-group
      [value]="colorBy()"
      (change)="colorByChange.emit($event.value)"
      aria-label="Color deliveries by"
    >
      <mat-button-toggle value="equipment">Equipment</mat-button-toggle>
      <mat-button-toggle value="operator">Operator</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="control-group control-group--right">
    <span class="control-label">View</span>
    <mat-button-toggle-group
      [value]="timeScale()"
      (change)="timeScaleChange.emit($event.value)"
      aria-label="Time scale"
    >
      <mat-button-toggle value="week">Week</mat-button-toggle>
      <mat-button-toggle value="month">Month</mat-button-toggle>
    </mat-button-toggle-group>

    <div class="nav-arrows" role="group" [attr.aria-label]="'Navigate ' + timeScale()">
      <button class="nav-btn" type="button" [attr.aria-label]="'Previous ' + timeScale()" (click)="navigate.emit(-1)">‹</button>
      <div class="nav-date-picker">
        <button class="nav-btn nav-btn--icon" type="button" [attr.aria-label]="'DELIVERIES.DATE' | translate" [title]="'DELIVERIES.DATE' | translate">
          <i class="fas fa-calendar-alt" aria-hidden="true"></i>
        </button>
        <input
          class="nav-date-input"
          type="date"
          [attr.aria-label]="'DELIVERIES.DATE' | translate"
          (change)="onDateInputChange($any($event.target).value)"
        />
      </div>
      <button class="nav-btn nav-btn--today" type="button" [attr.aria-label]="'GLOBAL.TODAY' | translate" (click)="todayClick.emit()">{{ 'GLOBAL.TODAY' | translate }}</button>
      <button class="nav-btn" type="button" [attr.aria-label]="'Next ' + timeScale()" (click)="navigate.emit(1)">›</button>
    </div>
  </div>
</div>
